import React from "react";

const UploadIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    stroke="currentColor"
    strokeWidth="2"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="17 8 12 3 7 8"></polyline>
    <line x1="12" y1="3" x2="12" y2="15"></line>
  </svg>
);

const InvoiceHeader = ({ selectedInvoice, setSelectedInvoice }) => {
  const cardStyle = {
    padding: "20px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e5e7eb",
    backgroundColor: "white",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
  };

  const titleStyle = {
    fontSize: "22px",
    fontWeight: 600,
    color: "#1f2937",
    maxWidth: "70%",
    overflow: "visible",
    wordBreak: "break-word",
    whiteSpace: "normal",
    lineHeight: 1.3,
  };

  // If no invoice is selected
  if (!selectedInvoice) {
    return (
      <div style={cardStyle}>
        <h2 style={titleStyle}>Upload Purchase Order</h2>
      </div>
    );
  }

  return (
    <div style={cardStyle}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          flexGrow: 1,
          maxWidth: "75%",
        }}
      >
        <h2 style={titleStyle}>{selectedInvoice.name}</h2>
        <p
          style={{
            margin: 0,
            color: "#6B7280",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span
            style={{
              display: "inline-block",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#22C55E",
            }}
          ></span>
          {selectedInvoice.date}
        </p>
      </div>

      <button
        onClick={() => setSelectedInvoice(null)}
        style={{
          backgroundColor: "#3B82F6",
          color: "white",
          border: "none",
          borderRadius: "8px",
          padding: "12px 20px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          cursor: "pointer",
          transition: "all 0.3s ease",
          fontSize: "15px",
          fontWeight: "500",
          flexShrink: 0,
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#2563EB";
          e.currentTarget.style.transform = "translateY(-1px)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#3B82F6";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <UploadIcon />
        Upload More PO
      </button>
    </div>
  );
};

export default InvoiceHeader;
